import { NextSeo, WebPageJsonLd } from "next-seo";
import { Navbar } from "~/components/Navbar/component";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { SOCIAL_OG_IMAGE_URL } from "~/consts";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { BreadcrumbSEO } from "~/modules/app/seo/BreadcrumbSEO";
import { TermsPage } from "~/modules/legal/pages/terms";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";

// // // //

const SEO_TITLE = "Terms of Use";
const SEO_DESCRIPTION =
    "Read the RWA.xyz Terms of Use governing your access to and use of the RWA.xyz website and services, provided by Castle Labs, Inc.";

// // // //

export default function Terms() {
    return (
        <PageTrack>
            <NextSeo
                title={SEO_TITLE}
                description={SEO_DESCRIPTION}
                canonical={addBaseUrl(Routes.termsOfUse)}
                openGraph={{
                    type: "website",
                    url: addBaseUrl(Routes.termsOfUse),
                    title: SEO_TITLE,
                    site_name: "RWA.xyz",
                    description: SEO_DESCRIPTION,
                    images: [
                        {
                            url: SOCIAL_OG_IMAGE_URL,
                            width: 4000,
                            height: 2300,
                            alt: "rwa.xyz",
                        },
                    ],
                }}
                additionalMetaTags={[
                    {
                        name: "keywords",
                        content:
                            "RWA.xyz terms of use, terms and conditions, terms of service, user agreement, legal",
                    },
                ]}
            />
            <WebPageJsonLd
                id={addBaseUrl(Routes.termsOfUse)}
                description={SEO_DESCRIPTION}
                reviewedBy={{
                    type: "Organization",
                    name: "RWA.xyz",
                }}
            />
            <BreadcrumbSEO
                items={[
                    {
                        name: SEO_TITLE,
                        href: Routes.termsOfUse,
                    },
                ]}
            />
            <UserFetcher>{({ user }) => <Navbar user={user} />}</UserFetcher>
            <SidebarLayout pathname={Routes.termsOfUse} showFooter>
                <PageWrapper>
                    <TermsPage />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
